import LiveSubProfilePic from "../../../../../assets/subscriptions/ProfilePhoto2Update.png";
import { LiveSubscriptionType } from "../../../types/LiveSubscriptionTypes.ts";
import { useAppDispatch, useAppSelector } from "../../../../../state/state.tsx";
import { openModal } from "../../../../../state/ModalSlice/ModalSlice.ts";
import parsePhoneNumber from 'libphonenumber-js';
import { useState } from 'react';
import ChangePhoneNumberModal from './ChangePhoneNumberModal';
import { SECRETS_ENV } from "../../../../../Config/firebase.ts";
import axios from "axios";

import {
    setFieldsForDeleteLiveSubscriptionModal,
    setFieldsForEditLiveSubscriptionModal,
    setFieldsForMultiMonthPauseModal,
    setFieldsForMultiMonthResumeModal,
    setFieldsForPauseLiveSubscriptionModal,
    setFieldsForResumeLiveSubscriptionModal,
    setFieldsForTerminateLiveSubscriptionModal,
    setFieldsForCancelPauseModal,
    setFieldsForSingleRaiseInvoiceModal,
    setFieldsForQuickCollectModal,
    setFieldsForMoveStudentModal
} from "../../../../../state/ArbitrarySlice/ArbitratySlice.ts";
import { toast } from "react-toastify";
import { formatDateAsDDMMYYYY, getFutureCycles } from "../../../../Common/utilityFunctions.ts";
import { SubscriptionType } from "../../../../../enums.ts";
import { differenceInDays } from "date-fns";
import { selectUserSliceV2Data } from "../../../../../state/UserStatesV2/userSliceV2.ts";

const STATUS_INFO_LEGEND: { label: string; description: string; colorClass: string }[] = [
    { label: "InActive", description: "The student is not live yet, services not yet available", colorClass: "text-red-800" },
    { label: "Active", description: "The student is live, all services are now available", colorClass: "text-cc_success" },
    { label: "Paused", description: "The student is temporarily on break and will resume later", colorClass: "text-amber-600" },
    { label: "Expired", description: "The student's validity has ended (end date reached)", colorClass: "text-orange-500" },
    { label: "Terminated", description: "The student is permanently removed and no longer considered in classes", colorClass: "text-red-950" },
];

export default function LiveSubInformationSection({ selectedLiveSubDoc, selectedSubscriptionPrice, isAlign2monthBoundary, NoGSTBatch, serviceProviderId, onDataRefresh }: {
    selectedLiveSubDoc: LiveSubscriptionType,
    selectedSubscriptionPrice: number,
    isAlign2monthBoundary: boolean,
    NoGSTBatch: boolean,
    serviceProviderId: string,
    onDataRefresh?: () => void
}) {

    const Dispatch = useAppDispatch();
    const [showChangePhoneModal, setShowChangePhoneModal] = useState(false);
    const [showStatusInfoModal, setShowStatusInfoModal] = useState(false);
    const [isCalling, setIsCalling] = useState(false);

    async function onClickCall() {
        setIsCalling(true);
        try {
            const response = await axios.post(`${SECRETS_ENV.API_END_POINT}/api/agenticRouter/initiateCall`, {
                serviceProviderId: serviceProviderId,
                liveSubscriptionId: selectedLiveSubDoc.id,
                phoneNumber: selectedLiveSubDoc.phoneNumber,
                studentName: selectedLiveSubDoc.studentName,
            });
            if (response.status >= 200 && response.status < 300) {
                toast.success("Call initiated successfully");
            } else {
                toast.error("Failed to initiate call");
            }
        } catch (error: any) {
            toast.error(error?.response?.data?.message || "Failed to initiate call");
        } finally {
            setIsCalling(false);
        }
    }
    const userData = useAppSelector(selectUserSliceV2Data);
    const durationLimitForMultiMonthSubscriptions = userData?.durationLimitForMultiMonthSubscriptions || 15;
    const countInvoiceThreshold = userData?.countInvoiceThreshold || 3;
        // OnClickHandlers


    function CheckIfInvoiceCanBeRaised() {
        if (selectedLiveSubDoc.subscriptionType === SubscriptionType.Monthly) {
            return {
                error: false,
                message: `Invoice can be raised`
            }


        } else if (selectedLiveSubDoc.subscriptionType === SubscriptionType.Count) {

            if (selectedLiveSubDoc.lastOrderStatus === "Pending") {
                return {
                    error: true,
                    message: `A pending order already exists. Please review and make the necessary updates to the existing order.`
                }
            }

            const remainingCount = selectedLiveSubDoc.remainingCount
            const endDate = new Date(selectedLiveSubDoc.billingEnd)
            const currentDate = new Date()
            const diffInDays = differenceInDays(endDate, currentDate)

            if (remainingCount <= countInvoiceThreshold || diffInDays < durationLimitForMultiMonthSubscriptions) {
                return {
                    error: false,
                    message: `An invoice can be raised for ${remainingCount % 1 === 0 ? remainingCount : remainingCount.toFixed(2)} remaining classes`
                }
            } else {
                return {
                    error: true,
                    message: `An invoice can be raised only if the remaining classes are less than ${countInvoiceThreshold}.`
                }
            }
        } else if (selectedLiveSubDoc.subscriptionType === SubscriptionType.MultiMonth) {

            const endDate = new Date(selectedLiveSubDoc.billingEnd)
            const currentDate = new Date()
            const diffInDays = differenceInDays(endDate, currentDate)
            if (diffInDays < durationLimitForMultiMonthSubscriptions) {
                return {
                    error: false,
                    message: `An invoice can be raised for ${diffInDays} days`
                }
            } else {
                return {
                    error: true,
                    message: `An invoice can be raised only if the remaining days are less than ${durationLimitForMultiMonthSubscriptions}.`
                }
            }
        }

        return {
            error: true,
            message: `Invoice cannot be raised for ${selectedLiveSubDoc.subscriptionType} subscription`
        }
    }



    function onClickPause() {
        // if (selectedLiveSubDoc.subscriptionType === SubscriptionType.Count) {
        //     toast.info("Pause is not applicable for Count Subscription")
        //     return;
        // }

        if (selectedLiveSubDoc.status === "Terminated") {
            toast.error("Terminated Student cannot be paused")
            return;
        }

        if (selectedLiveSubDoc.status === "InActive") {
            toast.error("Inactive Student cannot be paused")
            return;
        }

        if (selectedLiveSubDoc.cycle !== SubscriptionType.Monthly) {
            Dispatch(openModal("MultiMonthPauseModalOpen"))

            Dispatch(setFieldsForMultiMonthPauseModal({
                LiveSubscriptionId: selectedLiveSubDoc.id,
                align2monthlyBoundary: isAlign2monthBoundary
            }))
        } else {
            Dispatch(openModal("PauseLiveSubscriptionModalOpen"))
            Dispatch(setFieldsForPauseLiveSubscriptionModal({
                subscriptionId: selectedLiveSubDoc.subscriptionPlanRefId,
                LiveSubscriptionId: selectedLiveSubDoc.id
            }))
        }

    }

    function onClickTerminate() {

        if (selectedLiveSubDoc.status === "Terminated") {
            toast.error("Student is already Terminated")
            return;
        }
        Dispatch(openModal("TerminateLiveSubscriptionModalOpen"))

        Dispatch(setFieldsForTerminateLiveSubscriptionModal({
            SubscriptionId: selectedLiveSubDoc.subscriptionPlanRefId,
            LiveSubscriptionId: selectedLiveSubDoc.id
        }))
    }

    function onClickDelete() {
        if (selectedLiveSubDoc.status !== "Terminated") {
            toast.error("Terminate the subscriber before deleting.")
            return;
        }
        Dispatch(openModal("DeleteLiveSubscriptionModalOpen"))

        Dispatch(setFieldsForDeleteLiveSubscriptionModal({
            SubscriptionId: selectedLiveSubDoc.subscriptionPlanRefId,
            LiveSubscriptionId: selectedLiveSubDoc.id
        }))
    }

    function onClickEditLiveSubscription(LiveSubscriptionId: string) {
        Dispatch(openModal("EditLiveSubscriptionModalOpen"))
        Dispatch(setFieldsForEditLiveSubscriptionModal({ LiveSubscriptionId: LiveSubscriptionId, SubscriptionPrice: selectedSubscriptionPrice, NoGSTBatch: NoGSTBatch }))
    }

    function onClickResume() {
        if (selectedLiveSubDoc.status === "Terminated") {
            toast.error("Terminated Subscriber cannot be Resumed")
            return;
        }
        if (selectedLiveSubDoc.cycle !== SubscriptionType.Monthly) {
            Dispatch(openModal("MultiMonthResumeModalOpen"))
            Dispatch(setFieldsForMultiMonthResumeModal({
                LiveSubscriptionId: selectedLiveSubDoc.id,
                align2monthlyBoundary: isAlign2monthBoundary
            }))
        } else {
            Dispatch(openModal("ResumeLiveSubscriptionModalOpen"))
            Dispatch(setFieldsForResumeLiveSubscriptionModal({
                LiveSubscriptionId: selectedLiveSubDoc.id,
                SubscriptionId: selectedLiveSubDoc.subscriptionPlanRefId,
                chargeNowVisible: selectedLiveSubDoc.invoiceCycleList ? !selectedLiveSubDoc.invoiceCycleList.includes(getFutureCycles()[0]) : true
            }))
        }
    }

    function onClickCancelPause() {
        Dispatch(openModal("CancelPauseModalOpen"))
        Dispatch(setFieldsForCancelPauseModal({ LiveSubscriptionId: selectedLiveSubDoc.id, align2monthlyBoundary: isAlign2monthBoundary }))

    }

    function onClickSingleRaiseInvoice() {

        if (selectedLiveSubDoc.status === "Terminated" || selectedLiveSubDoc.status === "InActive" || selectedLiveSubDoc.status === "Paused") {
            toast.error(`Invoice cannot be raised for ${selectedLiveSubDoc.status} subscriber`)
            return;
        }

        const { error, message } = CheckIfInvoiceCanBeRaised()
        if (error) {
            toast.error(message)
            return;
        }
        Dispatch(setFieldsForSingleRaiseInvoiceModal({ subscriptionId: selectedLiveSubDoc.subscriptionPlanRefId, liveSubId: selectedLiveSubDoc.id }))
        Dispatch(openModal("SingleRaiseInvoiceModalOpen"))
        // Dispatch(setFieldsForRaiseInvoiceModal({ LiveSubscriptionId: selectedLiveSubDoc.id }))
    }



    function onClickQuickCollect() {
        if (selectedLiveSubDoc.status === "Terminated") {
            toast.error(`Quick Collect is not applicable for ${selectedLiveSubDoc.status} subscriber`)
            return;
        }

        Dispatch(setFieldsForQuickCollectModal({ subscriptionId: selectedLiveSubDoc.subscriptionPlanRefId, liveSubId: selectedLiveSubDoc.id }))
        Dispatch(openModal("QuickCollectModalOpen"))

    }

    function onClickMoveStudent() {
        if (selectedLiveSubDoc.status === "Terminated") {
            toast.error("Terminated student cannot be moved")
            return;
        }

        Dispatch(setFieldsForMoveStudentModal({ 
            LiveSubscriptionId: selectedLiveSubDoc.id,
            currentSubscriptionType: selectedLiveSubDoc.subscriptionType,
            lastOrderStatus: selectedLiveSubDoc.lastOrderStatus ?? ""
        }))
        Dispatch(openModal("MoveStudentModalOpen"))

    }


    const hasFuturePause = () => {
        if (!selectedLiveSubDoc.pauseHistory || selectedLiveSubDoc.pauseHistory.length === 0) return false;
        const lastPause = selectedLiveSubDoc.pauseHistory[selectedLiveSubDoc.pauseHistory.length - 1];
        const pauseDate = lastPause.pauseTS?.toDate?.() || new Date(lastPause.pauseTS);

        return pauseDate.getTime() > new Date().getTime();
    };

    const getMMPrice = () => {
        let assignedPlanPrice = 0;
        assignedPlanPrice = selectedLiveSubDoc.assignedPlans[selectedLiveSubDoc.assignedPlanIndex].price;
        return ((Number(assignedPlanPrice) * selectedLiveSubDoc.priceMultiplier)) + selectedLiveSubDoc.products.reduce((sum, product) => sum + Number(product.price || 0), 0)
    }

    if (!selectedLiveSubDoc) {

        return <div>Please select a live sub</div>
    }

    const phoneNumber = parsePhoneNumber(selectedLiveSubDoc.phoneNumber)

    const statusColorClass = selectedLiveSubDoc.status === "Active"
        ? "text-cc_success"
        : selectedLiveSubDoc.status === "Paused"
            ? "text-cc_bg-paused"
            : "text-cc_error";

    const renderStatusWithInfo = () => (
        <div className="flex flex-wrap items-center gap-1">
            <span className="text-gray-600">Status:</span>
            <span className={`font-medium ${statusColorClass}`}>{selectedLiveSubDoc.status}</span>
            <button
                type="button"
                onClick={() => setShowStatusInfoModal(true)}
                className="inline-flex text-gray-500 hover:text-gray-700 p-0.5 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-cc_brand focus-visible:ring-offset-1"
                aria-label="Open status information"
                title="Status information"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="16" x2="12" y2="12" />
                    <line x1="12" y1="8" x2="12.01" y2="8" />
                </svg>
            </button>
        </div>
    );

    return (
        <div
            className={"header w-full rounded-xl bg-cc_bg_ap p-3 sm:p-4 lg:p-5 flex flex-col border-solid border-[1px] border-cc_modal-grey-border"}>
            <div className={"flex flex-col sm:flex-row items-start sm:items-center w-full gap-3 sm:gap-0"}>
                <div className={"flex-shrink-0 p-1.5 sm:p-2 bg-white rounded-full border-solid border-gray-400 border-2 flex"}>
                    <img
                        className="inline-block size-12 sm:size-16 rounded-full ring-2 ring-white"
                        src={selectedLiveSubDoc.photoUrl || LiveSubProfilePic}
                        alt="Profile"
                    />
                </div>
                <div className={"flex-1 sm:ml-2.5 sm:max-w-[30%] min-w-0"}>
                    <p className={"text-base sm:text-lg font-semibold truncate"}>{selectedLiveSubDoc.studentName}</p>
                    <div className="flex items-center gap-1.5 sm:gap-2">
                        <p className={"text-xs sm:text-sm truncate"}>{phoneNumber?.formatInternational() || selectedLiveSubDoc.phoneNumber}</p>
                        <button
                            onClick={() => setShowChangePhoneModal(true)}
                            className="text-blue-600 hover:text-blue-800 p-0.5 sm:p-1 rounded hover:bg-blue-50 transition-colors flex-shrink-0"
                            title="Change phone number"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" className="sm:w-3.5 sm:h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                            </svg>
                        </button>
                    </div>
                    <p className={"text-[10px] sm:text-xs font-semibold mt-0.5 sm:mt-1 text-blue-800 truncate"}>id : {selectedLiveSubDoc.id}</p>
                    <button
                        onClick={onClickMoveStudent}
                        className="mt-1.5 sm:mt-2 text-xs sm:text-sm bg-purple-600 hover:bg-purple-700 text-white px-2 sm:px-3 py-1 sm:py-1.5 rounded-md transition-colors flex items-center gap-1 sm:gap-1.5"
                        title="Move student to another batch"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" className="sm:w-3.5 sm:h-3.5 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="17 11 12 6 7 11"></polyline>
                            <polyline points="17 18 12 13 7 18"></polyline>
                        </svg>
                        <span className="whitespace-nowrap">Move Student</span>
                    </button>
                </div>
                <div className={"grid grid-cols-2 sm:grid-cols-2 gap-1.5 sm:gap-2 ml-2 sm:ml-6 w-full sm:w-fit"}>
                    <button
                        onClick={onClickCall}
                        disabled={isCalling}
                        className={"col-span-2 bg-green-600 hover:bg-green-700 disabled:opacity-60 disabled:cursor-not-allowed text-white px-2 sm:px-3 py-1.5 sm:py-2 shadow-sm rounded-md text-xs sm:text-sm flex justify-center items-center gap-1 sm:gap-1.5 min-w-0"}
                        title="AI Call for Due"
                    >
                        {isCalling ? (
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" className="sm:w-3.5 sm:h-3.5 flex-shrink-0 animate-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
                            </svg>
                        ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" className="sm:w-3.5 sm:h-3.5 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.65 3.38 2 2 0 0 1 3.62 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.59a16 16 0 0 0 6 6l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"></path>
                            </svg>
                        )}
                        <span className="whitespace-nowrap">{isCalling ? "Calling..." : "AI Call for Dues"}</span>
                    </button>
                    <button onClick={() => {
                        onClickEditLiveSubscription(selectedLiveSubDoc.id)
                    }}
                        className={"bg-gray-100 border-[1px] border-gray-400 hover:bg-gray-200 text-black px-2 sm:px-3 py-1.5 sm:py-2 shadow-sm rounded-md text-xs sm:text-sm flex justify-center items-center gap-1 sm:gap-1.5 min-w-0"}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" className="sm:w-3.5 sm:h-3.5 flex-shrink-0 feather feather-edit" viewBox="0 0 24 24"
                            fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                            strokeLinejoin="round">
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                        </svg>
                        <span className="truncate">Edit</span>
                    </button>

                    <div>
                        {selectedLiveSubDoc.status === "Paused" ? (
                            <button onClick={onClickResume}
                                className={"w-full bg-gray-100 border-[1px] border-gray-400 hover:bg-gray-200 text-black px-2 sm:px-3 py-1.5 sm:py-2 shadow-sm rounded-md text-xs sm:text-sm flex justify-center items-center gap-1 sm:gap-1.5"}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" className="sm:w-3.5 sm:h-3.5 flex-shrink-0 feather feather-play" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                    strokeLinejoin="round">
                                    <polygon points="5 3 19 12 5 21 5 3"></polygon>
                                </svg>
                                <span className="truncate">Resume</span>
                            </button>
                        ) : selectedLiveSubDoc.subscriptionType === "MultiMonth" && hasFuturePause() ? (
                            <button onClick={onClickCancelPause}
                                className={"w-full bg-gray-100 border-[1px] border-gray-400 hover:bg-gray-200 text-black px-2 sm:px-3 py-1.5 sm:py-2 shadow-sm rounded-md text-xs sm:text-sm flex justify-center items-center gap-1 sm:gap-1.5"}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" className="sm:w-3.5 sm:h-3.5 flex-shrink-0 feather feather-x-circle" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                    strokeLinejoin="round">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line x1="15" y1="9" x2="9" y2="15"></line>
                                    <line x1="9" y1="9" x2="15" y2="15"></line>
                                </svg>
                                <span className="truncate text-[10px] sm:text-xs">Cancel</span>
                            </button>
                        ) : (
                            <button onClick={onClickPause}
                                className={"w-full bg-gray-100 border-[1px] border-gray-400 hover:bg-gray-200 text-black px-2 sm:px-3 py-1.5 sm:py-2 shadow-sm rounded-md text-xs sm:text-sm flex justify-center items-center gap-1 sm:gap-1.5"}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" className="sm:w-3.5 sm:h-3.5 flex-shrink-0 feather feather-pause" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                    strokeLinejoin="round">
                                    <rect x="6" y="4" width="4" height="16"></rect>
                                    <rect x="14" y="4" width="4" height="16"></rect>
                                </svg>
                                <span className="truncate">Pause</span>
                            </button>
                        )}
                    </div>

                    <button onClick={onClickTerminate}
                        className={"bg-gray-100 border-[1px] border-gray-400 hover:bg-gray-200 text-black px-2 sm:px-3 py-1.5 sm:py-2 shadow-sm rounded-md text-xs sm:text-sm flex justify-center items-center gap-1 sm:gap-1.5 min-w-0"}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" className="sm:w-3.5 sm:h-3.5 flex-shrink-0 feather feather-minus-square" viewBox="0 0 24 24"
                            fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                            strokeLinejoin="round">
                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                            <line x1="8" y1="12" x2="16" y2="12"></line>
                        </svg>
                        <span className="truncate text-[10px] sm:text-xs">Terminate</span>
                    </button>
                    <button onClick={onClickDelete}
                        className={"bg-gray-100 border-[1px] border-gray-400 hover:bg-gray-200 text-black px-2 sm:px-3 py-1.5 sm:py-2 shadow-sm rounded-md text-xs sm:text-sm flex justify-center items-center gap-1 sm:gap-1.5 min-w-0"}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" className="sm:w-3.5 sm:h-3.5 flex-shrink-0 feather feather-trash-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                        <span className="truncate">Delete</span>
                    </button>
                </div>
            </div>
            <div className="pl-2 sm:pl-4 lg:pl-6 mt-3 sm:mt-4 mb-1 space-y-1">
                <div className="text-sm sm:text-base">
                    {renderStatusWithInfo()}
                </div>
                {selectedLiveSubDoc.subscriptionType === SubscriptionType.Count && selectedLiveSubDoc.status !== "InActive" && (
                    <p className="text-sm sm:text-base lg:text-lg font-semibold">
                        Remaining Classes : {selectedLiveSubDoc.remainingCount % 1 === 0 ? selectedLiveSubDoc.remainingCount : selectedLiveSubDoc.remainingCount.toFixed(2)}
                    </p>
                )}
            </div>

            <div className="bg-white rounded-lg ml-0 sm:ml-1 shadow-md border border-gray-200 w-full sm:w-[80%] my-3 sm:my-4 overflow-hidden text-xs sm:text-sm">
                <div className="bg-cc_brand text-white p-2 sm:p-3 flex justify-between items-center">
                    <h2 className="text-sm sm:text-base font-bold">Subscription Details</h2>
                </div>
                <div className="p-2 sm:p-3 bg-gray-50">
                    <div className="mb-2">
                        <div>
                            <span className="text-gray-600">Service:</span>
                            <span className="font-medium ml-1">{selectedLiveSubDoc.serviceType}</span>
                        </div>
                        <div className="mt-1 grid grid-cols-2 gap2">
                            {(selectedLiveSubDoc.subscriptionType === SubscriptionType.MultiMonth || selectedLiveSubDoc.subscriptionType === SubscriptionType.Count) &&
                                (selectedLiveSubDoc.status === "Active" || selectedLiveSubDoc.status === "Paused") &&
                                selectedLiveSubDoc.billingEnd && (

                                    <div className="">
                                        <span className="text-gray-600">Validity:</span>
                                        <span className="font-medium ml-1">
                                            {formatDateAsDDMMYYYY(new Date(selectedLiveSubDoc.billingStart))} - {formatDateAsDDMMYYYY(new Date(selectedLiveSubDoc.billingEnd))}
                                        </span>
                                    </div>
                                )}
                            {/* {(selectedLiveSubDoc.subscriptionType === SubscriptionType.MultiMonth || selectedLiveSubDoc.subscriptionType === SubscriptionType.Count) &&
                                <div className={`${(selectedLiveSubDoc.status === "Active" || selectedLiveSubDoc.status === "Paused") ? "pl-4" : "pl-0"}`}>
                                    <span className="text-gray-600">Discount:</span>
                                    <span className="font-medium ml-1">₹{selectedLiveSubDoc.discountNegotiated}</span>
                                </div>
                            } */}
                            {(selectedLiveSubDoc.subscriptionType === SubscriptionType.Monthly) && (
                                <div className="pl-0">
                                    <span className="text-gray-600">Start Date:</span>

                                    <span className="font-medium ml-1">{formatDateAsDDMMYYYY(new Date(selectedLiveSubDoc.startDate))}</span>
                                </div>
                            )}
                        </div>



                    </div>

                    <div className="bg-white p-2 rounded border border-gray-200">

                        {selectedLiveSubDoc.serviceType !== "CableTV" && (
                            <div className="flex justify-between items-center mb-1">
                                <span className="text-gray-600">{selectedLiveSubDoc.subscriptionType === SubscriptionType.MultiMonth ? `Plan Price ( ${selectedLiveSubDoc.assignedPlans?.[selectedLiveSubDoc.assignedPlanIndex || 0]?.billingCycle} ) ` : "Plan Price"}:</span>
                                <span className="font-medium">₹{(selectedLiveSubDoc.subscriptionType === SubscriptionType.Monthly) ? selectedLiveSubDoc.Price || selectedSubscriptionPrice : (selectedLiveSubDoc.assignedPlans?.[selectedLiveSubDoc.assignedPlanIndex || 0]?.price)}</span>
                            </div>
                        )}
                        {selectedLiveSubDoc.serviceType !== "CableTV" && (selectedLiveSubDoc.subscriptionType !== SubscriptionType.Count && selectedLiveSubDoc.subscriptionType !== SubscriptionType.MultiMonth) && (
                            <div className="flex justify-between items-center mb-1">
                                <span className="text-gray-600">(Multiplier :{selectedLiveSubDoc.priceMultiplier}, Discount :₹{selectedLiveSubDoc.discountNegotiated})</span>

                            </div>
                        )}
                        {/* {(selectedLiveSubDoc.subscriptionType === SubscriptionType.Count || selectedLiveSubDoc.subscriptionType === SubscriptionType.MultiMonth) && (
                            <div className="flex justify-between items-center mb-1">
                                <span className="text-gray-600">(Discount :₹{selectedLiveSubDoc.discountNegotiated})</span>

                            </div>
                        )} */}

                        {selectedLiveSubDoc.products && selectedLiveSubDoc.products.length > 0 && (
                            selectedLiveSubDoc.products.map((product, index) => (
                                product && Object.keys(product).length > 0 && (
                                    <div key={index} className="flex justify-between items-center mb-1">
                                        <span className="text-gray-600">{product.name}:</span>
                                        <span className="font-medium">₹{product.price}</span>
                                    </div>
                                )
                            ))
                        )}
                        <div className="flex justify-between items-center pt-1 border-t border-gray-200 mt-1">
                            <span className="font-bold text-cc_brand">Total Charges:</span>
                            <span className="font-bold text-cc_brand">
                                ₹{selectedLiveSubDoc.serviceType !== "CableTV"
                                    ? (selectedLiveSubDoc.subscriptionType === SubscriptionType.Count || selectedLiveSubDoc.subscriptionType === SubscriptionType.MultiMonth)
                                        ? getMMPrice()
                                        : ((Number(selectedLiveSubDoc.Price || selectedSubscriptionPrice) * selectedLiveSubDoc.priceMultiplier) - selectedLiveSubDoc.discountNegotiated) + selectedLiveSubDoc.products.reduce((sum, product) => sum + Number(product.price || 0), 0)
                                    : selectedLiveSubDoc.products.reduce((sum, product) => sum + Number(product.price || 0), 0)}
                            </span>
                        </div>

                        {/* Add Raise Invoice button */}
                        {<div className="mt-3 flex flex-col sm:flex-row justify-end gap-2 sm:gap-2.5">
                            <button
                                onClick={() => {
                                    onClickQuickCollect()
                                }}
                                className="bg-cc_brand text-white px-4 sm:px-6 lg:px-10 py-1.5 sm:py-2 rounded-lg flex items-center justify-center gap-1.5 sm:gap-2 hover:bg-cc_brand/90 transition-colors text-xs sm:text-sm font-medium"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" className="sm:w-4 sm:h-4 flex-shrink-0 feather feather-file-text" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                    strokeLinejoin="round">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                    <polyline points="14 2 14 8 20 8"></polyline>
                                    <line x1="16" y1="13" x2="8" y2="13"></line>
                                    <line x1="16" y1="17" x2="8" y2="17"></line>
                                    <polyline points="10 9 9 9 8 9"></polyline>
                                </svg>
                                <span className="whitespace-nowrap">Quick Collect</span>
                            </button>
                            <button
                                onClick={() => {
                                    onClickSingleRaiseInvoice()
                                }}
                                className="bg-cc_brand text-white px-4 sm:px-6 lg:px-10 py-1.5 sm:py-2 rounded-lg flex items-center justify-center gap-1.5 sm:gap-2 hover:bg-cc_brand/90 transition-colors text-xs sm:text-sm font-medium"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" className="sm:w-4 sm:h-4 flex-shrink-0 feather feather-file-text" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                    strokeLinejoin="round">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                    <polyline points="14 2 14 8 20 8"></polyline>
                                    <line x1="16" y1="13" x2="8" y2="13"></line>
                                    <line x1="16" y1="17" x2="8" y2="17"></line>
                                    <polyline points="10 9 9 9 8 9"></polyline>
                                </svg>
                                <span className="whitespace-nowrap">Raise Invoice</span>
                            </button>
                        </div>}
                    </div>
                    {selectedLiveSubDoc.serviceType !== "CableTV" && (selectedLiveSubDoc.subscriptionType !== SubscriptionType.Count && selectedLiveSubDoc.subscriptionType !== SubscriptionType.MultiMonth) && (
                        <div className="text-xs text-gray-500 mt-1">
                            *Charges = (Plan Price x Multiplier) - Discount + Products
                        </div>
                    )}
                    {(selectedLiveSubDoc.subscriptionType === SubscriptionType.Count || selectedLiveSubDoc.subscriptionType === SubscriptionType.MultiMonth) && (
                        <div className="text-xs text-gray-500 mt-1">
                            *Charges = Plan Price - Discount
                        </div>
                    )}
                </div>
            </div>

            {showStatusInfoModal && (
                <div
                    className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/40"
                    role="presentation"
                    onClick={() => setShowStatusInfoModal(false)}
                >
                    <div
                        role="dialog"
                        aria-labelledby="status-info-title"
                        className="bg-white rounded-lg shadow-lg max-w-lg w-full border border-gray-200 overflow-hidden"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex justify-between items-center px-4 py-3 border-b border-gray-100">
                            <h3 id="status-info-title" className="text-sm sm:text-base font-bold text-gray-900">
                                Status Info
                            </h3>
                            <button
                                type="button"
                                onClick={() => setShowStatusInfoModal(false)}
                                className="p-1 rounded text-gray-500 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-cc_brand"
                                aria-label="Close"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                                    <line x1="18" y1="6" x2="6" y2="18" />
                                    <line x1="6" y1="6" x2="18" y2="18" />
                                </svg>
                            </button>
                        </div>
                        <div className="px-4 py-3 max-h-[min(70vh,28rem)] overflow-y-auto">
                            <ul className="space-y-3 text-xs sm:text-sm">
                                {STATUS_INFO_LEGEND.map((row) => (
                                    <li key={row.label} className="grid grid-cols-[minmax(0,6.5rem)_1fr] gap-x-3 items-start">
                                        <span className={`font-semibold ${row.colorClass}`}>{row.label}</span>
                                        <span className={row.colorClass}>{row.description}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            )}

            {/* Change Phone Number Modal */}
            <ChangePhoneNumberModal
                open={showChangePhoneModal}
                onClose={() => setShowChangePhoneModal(false)}
                currentPhoneNumber={selectedLiveSubDoc.phoneNumber}
                studentName={selectedLiveSubDoc.studentName}
                liveSubscriptionId={selectedLiveSubDoc.id}
                serviceProviderId={serviceProviderId}
                onPhoneNumberChanged={() => {
                    onDataRefresh?.();
                    setShowChangePhoneModal(false);
                }}
            />
        </div>
    )
}